import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Divider, RaisedButton, Card, CardText } from "material-ui";
import { } from "../../Global/actions";
// import { ModalSolicitudReajustePaso } from "../SolicitudReajuste/actions";
import styles from "../../styles/styles";
import urlHelper from "../../../helpers/urlHelper";
import SolicitudReajusteReplicar from "./replicar";

class SolicitudReajusteRespuesta extends React.Component {
  componentWillMount() {
  }

  ModalSolicitudReajuste = () => {
    urlHelper.RedirectTo("SolicitudesRealizadas");
    // this.props.dispatch(ModalSolicitudReajustePaso(0));
  }

  render() {
    const itemsCentrosAtencion = [];
    this.props.checkCentrosAtencion.forEach((element, index) => {
      itemsCentrosAtencion.push((
        <li key={`centrosAtencion${index}`}>{this.props.centrosAtencion.filter((p) => p.Secuencia === element)[0].Descripcion}</li>
      ));
    });

    const itemsTiposPrestacion = [];
    this.props.checkTiposPrestacion.forEach((element, index) => {
      itemsTiposPrestacion.push((
        <li key={`tiposPrestacion${index}`}>{this.props.tiposPrestaciones.filter((p) => p.Id === element)[0].Descripcion}</li>
      ));
    });

    const itemsArancel = [];
    this.props.checkAranceles.forEach((element, index) => {
      itemsArancel.push((
        <li key={`tiposArancel${index}`}>{this.props.tiposArancel.filter((p) => p.Rut === element)[0].Descripcion}</li>
      ));
    });

    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>Solicitar Reajuste por IPC
                  </div>
                  <div style={styles.h2}>
                    Se ha enviado exitosamente su solicitud de Reajuste por IPC a continuación se detallan los números de solicitud:
                  </div>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0, marginTop: 15, marginBottom: 10 }}>
                <div style={styles.colSelectFieldActualizar}>
                  {this.props.periodoReajuste.ValidoArancel === 1 ?
                    <div style={styles.tituloReajustarPrestacionIpc}>
                      Reajuste Arancel: {this.props.cabeceraSolicitud.IdSolicitud !== null ? this.props.cabeceraSolicitud.IdSolicitud + " " + (this.props.isapre === 'B' ? 'Banmédica ' : 'Vida Tres ') : 'Cargando... '}{this.props.replicaArancel === 1 && this.props.cabeceraSolicitud.IdSolicitudReplicada !== null ? "- " + this.props.cabeceraSolicitud.IdSolicitudReplicada + " " + (this.props.isapre === 'B' ? 'Vida Tres.' : 'Banmédica.') : (this.props.replicaArancel === 1 ? ' Cargando...' : null)}
                    </div> : null}
                  <div style={{ marginBottom: 10 }}></div>
                  {this.props.periodoReajustePQ.ValidoPaquetes === 1 ?
                    <div style={styles.tituloReajustarPrestacionIpc}>
                      Reajuste Paquetes: {this.props.cabeceraSolicitud.IdSolicitudPQ !== null ? this.props.cabeceraSolicitud.IdSolicitudPQ + " " + (this.props.isapre === 'B' ? 'Banmédica ' : 'Vida Tres ') : 'Cargando... '}{this.props.replicaPaquetes === 1 && this.props.cabeceraSolicitud.IdSolicitudPQReplicada !== null ? "- " + this.props.cabeceraSolicitud.IdSolicitudPQReplicada + " " + (this.props.isapre === 'B' ? 'Vida Tres.' : 'Banmédica.') : (this.props.replicaPaquetes === 1 ? ' Cargando...' : null)}
                    </div> : null}
                </div>
              </div>

              {/*<SolicitudReajusteReplicar />*/}

              <div className="row" style={{ paddingBottom: 0, marginTop: 10, marginBottom: 20 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h2}>
                    La resolución de su solicitud será notificada vía electrónica a su email de
                    contacto. De igual forma podrá revisar lo solicitado y el estado de su
                    solicitud en el menú &#34;Solicitudes realizadas&#34;.
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12" style={{ textAlign: "right", marginTop: 10, marginBottom: 10 }}>
                  <RaisedButton
                    label="Finalizar"
                    onClick={this.ModalSolicitudReajuste}
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ borderRadius: 5 }}
                  />
                </div>
              </div>
            </CardText>
          </Card>
        </div>
      </div>
    );
  }
}

SolicitudReajusteRespuesta.propTypes = {
  rutInstitucion: PropTypes.number.isRequired,
  valorReajuste: PropTypes.number.isRequired,
  tiposArancel: PropTypes.array.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  tiposPrestaciones: PropTypes.array.isRequired,
  checkCentrosAtencion: PropTypes.array.isRequired,
  checkTiposPrestacion: PropTypes.array.isRequired,
  checkAranceles: PropTypes.array.isRequired,
  periodoReajuste: PropTypes.any.isRequired,
  periodoReajustePQ: PropTypes.any.isRequired,
  cabeceraSolicitud: PropTypes.any.isRequired,
  isapre: PropTypes.string.isRequired,
  replicaArancel: PropTypes.number.isRequired,
  replicaPaquetes: PropTypes.number.isRequired,
  // dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  rutInstitucion: state.global.rutInstitucion,
  valorReajuste: state.solicitudReajuste.valorReajuste,
  isapre: state.global.isapre,
  tiposArancel: state.global.tiposArancel,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  tiposPrestaciones: state.global.tiposPrestaciones,
  checkCentrosAtencion: state.solicitudReajuste.checkCentrosAtencion,
  checkTiposPrestacion: state.solicitudReajuste.checkTiposPrestacion,
  checkAranceles: state.solicitudReajuste.checkAranceles,
  periodoReajuste: state.filtroBusquedaRA.periodoReajuste,
  periodoReajustePQ: state.filtroBusquedaRA.periodoReajustePQ,
  cabeceraSolicitud: state.solicitudReajuste.cabeceraSolicitud,
  replicaArancel: state.solicitudReajuste.replicaArancel,
  replicaPaquetes: state.solicitudReajuste.replicaPaquetes,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(SolicitudReajusteRespuesta);

